import { useState } from 'react'
import { Layout, Button, Menu } from 'antd'
import { Link } from "react-router-dom"
import { LeftOutlined } from '@ant-design/icons'
import Feather from '@sysunite/react-feather'
import WeaverService from 'Services/WeaverService'
import { Switch, Route, withRouter } from 'react-router-dom'
import Data from './Data'
import ActionsPages from './ActionsPages'
import ActionsPagesDetail from './ActionsPages/Detail'
import Views from './Views'
import ViewDetail from './Views/Detail'
import Macros from './Macros'
import MacroDetail from './Macros/Detail'
{ Header, Sider } = Layout
{ SubMenu } = Menu

Settings = ({  history, match }) ->
  { path, params: { spaceId }} = match

  <Layout
    style={{ overflow: 'auto' }}
    data-testid='space-settings-container'
  >
    <Switch>
      <Route path="#{ path }/data"><Data /></Route>
      <Route path="#{ path }/services/:actionsPageId"><ActionsPagesDetail /></Route>
      <Route path="#{ path }/services"><ActionsPages /></Route>
      <Route path="#{ path }/views/:viewId"><ViewDetail /></Route>
      <Route path="#{ path }/views"><Views /></Route>
      <Route path="#{ path }/forms/:formId"><MacroDetail /></Route>
      <Route path="#{ path }/forms"><Macros/></Route>
    </Switch>
  </Layout>

export default withRouter(Settings)
